import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import BASE_URL from '../config';
import './CategoryList.css';

const CategoryList = () => {
  const [categories, setCategories] = useState([]);
  const [productCounts, setProductCounts] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    Promise.all([
      axios.get(`${BASE_URL}/api/categories/?format=json`),
      axios.get(`${BASE_URL}/api/products/?format=json`)
    ])
      .then(([catRes, prodRes]) => {
        setCategories(catRes.data);
        // Count products per category
        const counts = {};
        prodRes.data.forEach(product => {
          if (product.category?.slug) {
            counts[product.category.slug] = (counts[product.category.slug] || 0) + 1;
          }
        });
        setProductCounts(counts);
        setLoading(false);
      })
      .catch(err => {
        setError(err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="catlist-loading">
        <div className="spinner-border text-primary" role="status"></div>
      </div>
    );
  }

  if (error) return <p className="catlist-error">Error: {error.message}</p>;

  return (
    <div className="catlist-page">
      <h1 className="catlist-title">Categories</h1>
      <p className="catlist-subtitle">Browse our collection by category</p>

      <div className="catlist-grid">
        {categories.map(category => (
          <Link
            to={`/categories/${category.slug}`}
            key={category.id}
            className="catlist-card"
          >
            <div className="catlist-card-icon">
              {category.name.charAt(0)}
            </div>
            <h2 className="catlist-card-name">{category.name}</h2>
            <p className="catlist-card-count">
              {productCounts[category.slug] || 0} {(productCounts[category.slug] || 0) === 1 ? 'product' : 'products'}
            </p>
            <span className="catlist-card-arrow">→</span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default CategoryList;
